import { render, staticRenderFns } from "./AddKeywordComponent.vue?vue&type=template&id=08e6c3e3&"
import script from "./AddKeywordComponent.vue?vue&type=script&lang=js&"
export * from "./AddKeywordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports